import { render } from "./LockedField.vue?vue&type=template&id=1fe082c9&scoped=true&ts=true"
import script from "./LockedField.vue?vue&type=script&lang=ts"
export * from "./LockedField.vue?vue&type=script&lang=ts"

import "./LockedField.vue?vue&type=style&index=0&id=1fe082c9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe082c9"]])

export default __exports__